export default __webpack_public_path__ + "static/guru-hub-27fa931f1e0c2abd96c448f809e8fbfe.gif";